export default {
  title: {
    addJob: '发布新职位',
    editJob: '编辑职位',
    addTemplate: '添加职位模板',
    editTemplate: '编辑职位模板',
    step: {
      BASE_INFO: '基本职位信息',
      ADDITIONAL_INFO: '附加职位信息',
      DESCRIPTION_INFO: '具体职位描述',
      APPLICATION_CONFIG: '申请设置',
      OPEN_QUESTION: '申请问卷',
      POST_CHANNEL: '发布渠道',
      PERSONALITY_CALIBRATION: '性格基准',
      STATUS_HISTORY: '职位开放状态',
      AI_COMPARISON_CRITERION: '候选人AI对比标准',
      AI_INTERVIEW_ROOM: 'AI面试间',
      JOB_FIT_CONDITION: '候选人 AI 匹配度标准'
    },
    jobSettingsTitle: '职位设置',
    automationSettingsTitle: '自动化设置',
    customContent: {
      text: '文字',
      silder: '轮播图',
      picture: '图片组合',
      video: '视频'
    }
  },
  label: {
    stepName: {
      BASE_INFO: '基本职位信息',
      ADDITIONAL_INFO: '附加职位信息',
      DESCRIPTION_INFO: '具体职位描述',
      APPLICATION_CONFIG: '职位申请设置',
      OPEN_QUESTION: '职位申请问卷',
      POST_CHANNEL: '职位发布渠道',
      PERSONALITY_CALIBRATION: '职位性格基准',
      STATUS_HISTORY: '职位开放状态',
      AI_COMPARISON_CRITERION: '候选人AI对比标准',
      AI_INTERVIEW_ROOM: 'AI面试间',
      JOB_FIT_CONDITION: '候选人 AI 匹配度标准'
    },
    isEditableTemplate: '模板职位属性',
    jobTemplate: '职位模板 ',
    company: '公司名称',
    storeFront: '门店',
    jobCreator: '职位创建人',
    jobMember: '职位协作',
    jobCnName: '职位中文名称',
    jobEnName: '职位英文名称',
    jobVisibility: '职位可见性',
    atsId: '第三方职位ID',
    tag: '标签',
    visibleOnlyMember: '仅创建人和协作人可见',
    requireExperience: '工作类型',
    roleType: '工作性质',
    location: '地理位置',
    experience: '经验要求',
    salary: '薪酬',
    workTime: '工作时间',
    industryType: '行业/工种',
    jobCloseDate: '职位关闭日期',
    attractiveWords: '公关文字',
    scaleWithValue: '{scale}分制',
    noScale: '无',
    showCompanyCustomDetailPage: '公司级别职位详情页自定义',
    showVideoGuide: '视频导览',
    videoNavigationCn: '导览视频（中文）',
    videoNavigationEn: '导览视频（英文）',
    videoSourceLibrary: '媒体资源库（视频）',
    pcCnDetailHeader: '电脑端职位描述页眉（中文）',
    mobileCnDetailHeader: '手机端职位描述页眉（中文）',
    pcCnDetailFooter: '电脑端职位描述页脚（中文）',
    mobileCnDetailFooter: '手机端职位描述页脚（中文）',
    pcEnDetailHeader: '电脑端职位描述页眉（英文）',
    mobileEnDetailHeader: '手机端职位描述页眉（英文）',
    pcEnDetailFooter: '电脑端职位描述页脚（英文）',
    mobileEnDetailFooter: '手机端职位描述页脚（英文）',
    cnDetailHead: '职位描述页眉（中文）',
    cnDetail: '中文描述',
    cnDetailFoot: '职位描述页脚（中文）',
    enDetailHead: '职位描述页眉（英文）',
    enDetail: '英文描述',
    enDetailFoot: '职位描述页脚（英文）',
    reminderEmail: '接收提醒邮箱',
    resumeEmail: '接收简历邮箱',
    show: '显示',
    notShow: '不显示',
    locationSelector: {
      city: '城市',
      region: '区',
      cbd: '商圈',
      address: '详细地址'
    },
    resumeType: '简历',
    enableAssessment: '测评',
    assessmentType: '问卷类型',
    valuesAssessment: '价值观及优势测评',
    personalityAssessment: '性格测评',
    problemSolutionAssessment: '问题解决能力测评',
    careerPreferenceAssessment: '职业倾向问题',
    canReapplyDays: '允许再次申请（单位：天）',
    jobStatus: '职位状态',
    applyUrl: '申请链接',
    statusHistory: '职位状态历史',
    editable: '可编辑',
    notEditable: '不可编辑',
    workTimeNotSpecified: '不限',
    candidateApplySatisfactionSurvey: '求职者申请满意度调查',
    candidateInterviewSatisfactionSurvey: '求职者面试满意度调查',
    hmInterviewSatisfactionSurvey: 'HM面试满意度调查',
    hmGradeSatisfactionSurvey: 'HM评分满意度调查',
    channelAdditionalInfoTitle: '发布渠道补充信息',
    channelAdditionalInfo: {
      job_name: '职位名称',
      industry: '行业/工种'
    },
    jobSettings: {
      jobSettingTitle: '职位设置',
      jobCloseSettingTitle: '职位关闭邮件通知',
      jobCancelSettingTitle: '职位取消邮件通知',
      jobClosePrevContent: '当职位关闭时，发送',
      jobSettingsSendTo: '给未达到',
      jobSettingsEnd: '状态的候选人。',
      jobCancelPrevContent: '当职位取消时，发送',
      jobCloseApplicationStatusTitle: '职位关闭时更新申请状态',
      jobCancelApplicationStatusTitle: '职位取消时更新申请状态',
      jobCloseApplicationSourceStatus: '当职位关闭时，将以下状态的申请',
      jobCancelApplicationSourceStatus: '当职位取消时，将以下状态的申请',
      jobCloseApplicationTargetStatus: '更新为',
      jobCancelApplicationTargetStatus: '更新为'
    },
    automationSettingsTitle: '自动化设置',
    companyPolicySettings: '协议设置',
    revokeEmailAddress: '候选人撤回申请发送通知邮件至',
    revokeNoticeCandidateTitle: '通知候选人-候选人撤回申请/撤回个人数据',
    interviewSatisfactionTitle: '满意度调查设置',
    interviewSatisfactionSetting: '发送面试满意度调查于',
    resultStatusAutomation: {
      title: '候选人状态设置',
      hmRatingEnabled: '候选人状态根据评估结果变更',
      interviewResultEnabled: '候选人状态根据面试结果变更'
    },
    aiSettings: {
      title: 'AI展示逻辑',
      candidateAiFitScoreForHmEnabled: '向面试官展示候选人 AI 匹配度分数'
    },
    birthdayReminderTitle: '生日提醒设置',
    birthdayReminderToCandidate: '发送生日提醒至候选人',
    birthdayReminderToEmployee: '发送生日提醒至员工',
    birthdayReminderToAlumni: '发送生日提醒至前员工',
    banner: 'Banner',
    backToJobList: '职位列表',
    prevJob: '上一个职位',
    nextJob: '下一个职位',
    adpReferralRewardMessage: '200积分',
    adpReferralTipMessage: '实际情况以ADP微信推荐奖励政策为准',
    experienceLabel: '{experience}年',
    agreePolicyTitle: '请同意以下协议',
    referralRewardTitle: '推荐 / 分享',
    referralOrShareTip: '点击‘分享’分享职位给你的朋友，或者点击‘提交’直接提交你朋友的简历',
    experienceUnlimited: '不限',
    referralQrCodeTip: '直接发送此二维码给你的朋友申请吧！（如果需要微信转发，请关闭此弹窗，点击微信按钮扫一扫转发）',
    referralRoleTitle: '推荐',
    referralRoleTipContent: '你是{company}员工吗？',
    locationMap: '工作地点',
    jobDescription: '工作描述',
    shareToWeChat: '分享至微信',
    jobDetailSalary: '薪水',
    jobDetailRoleType: '工作性质',
    jobDetailExperience: '工作经验',
    jobDetailWorkTime: '工作时间',
    jobUpdateTime: '职位更新时间',
    shareToWeChatLogin: '通过微信扫一扫，分享给你的朋友吧（请注意不要直接发送此二维码给你的朋友）',
    changeStatusSettingsTitle: '候选人状态逻辑',
    changeStatusSettingsTip: '未同意协议候选人状态无法更新为',
    loginSettingsTitle: '全局安全',
    loginSettingsSessionAge: '登录会话的过期时间',
    loginSettingsSessionAgeTip: '小时',
    loginSettingsEmployeeAutoWxLogin: '员工账号自动登录（微信）',
    applicationReminderSettings: {
      title: '提醒设置',
      regarding: '对于',
      applicationWillNotBeSent: '来源的候选人不发送',
      continueToCompleteTheConsent: '继续完成协议',
      continueToCompleteTheApplication: '继续完成申请',
      via: '的',
      email: '邮件',
      sms: '短信',
      weChat: '微信',
      hrNoticeTitle: '员工推荐提醒职位创建人',
      jobMemberNoticeTitle: '员工推荐提醒职位协作者'
    },
    companyJobPoster: '公司海报',
    ambassadorJobPoster: '我的海报',
    customJobPoster: '新增海报',
    instructionsJobPoster: '海报指导',
    viewMore: '查看更多',
    shareTitle: '发送至：',
    jobPosterTitle: '职位海报：',
    aiJobRequirementCriterionTipFirst: 'AJINGA智能候选人对比使用人工智能来帮助您对比候选人以进行筛选。此步骤的目的是确定要在对比候选人中使用的标准。',
    aiJobRequirementCriterionTipSecond: '根据职位描述，AJINGA 智能体建议您考虑使用以下一些标准。单击标准将其添加到列表中。您还可以添加新标准并调整列表顺序。您的选择都将反映在最终候选人的对比表格中。',
    aiJobRequirementCriterionTipThird: '您可以随时回来更新您的选择。',
    selectAIJobRequirementCriterionTip: '我的标准',
    suggestionAIJobRequirementCriterionTip: 'AJINGA 智能推荐标准',
    addAICriterionTip: '添加标准',
    jobRequirementCriterionName: '标准',
    confirmRefreshCriterionTitle: '刷新建议标准（如果职位描述有更新）',
    confirmRefreshCriterionContent: '如果你更新了职位描述，需要AI提供建议标准，点击这里刷新',
    emailIsDisabled: '{email}（已禁用）',
    hiddenPadding: '隐藏内边距',
    selectJobInterviewRoom: '选择AI面试间',
    testCandidate: '测试',
    test: '测试',
    candidateName: '姓名：',
    testResultWithColon: '测试结果：'
  },
  placeholder: {
    customContent: {
      title: '请输入标题',
      videoCoverSize: '建议尺寸为640*480',
      videoSize: '建议为标清（640x480，不超过1080x720）1分钟视频',
      imageSize: '建议宽度为1440px',
      imageOrVideoSize: '建议图片宽度为1440px，视频仅支持mp4格式，最大{fileSize}MB',
      pictureSize: '图片将会并排横向排列。建议上传的图片尺寸为300*300以下',
      imageDescription: '请输入文字描述',
      imageLink: '请输入链接地址',
      videoDescription: '请输入文字描述',
      videoName: '视频名称'
    },
    canReapplyDays: '空或0意味着不允许求职者重复申请',
    location: {
      city: '请选择城市',
      region: '请选择地区',
      cbd: '请选择商圈',
      address: '请填写具体地址'
    },
    filterCity: '请选择城市',
    searchKeywords: '关键字搜索',
    channelAdditionalInfo: {
      job_name: '仅用于简历解析',
      industry: '请选择行业/工种'
    }
  },
  btn: {
    selectQuestionnaire: '选择问卷',
    addTag: '添加标签',
    createLocation: '添加新地址',
    selectLocation: '选取已有地址',
    addLocation: '添加地址',
    confirmAddEmail: '确认添加邮箱',
    jobStatus: {
      ACTIVE: '激活',
      PENDING: '待定',
      CLOSED: '关闭',
      CANCEL: '取消'
    },
    customContent: {
      addVideoCover: '添加视频封面',
      addVideo: '添加视频',
      addImage: '添加图片',
      addImageOrVideo: '添加图片/视频',
      addPicture: '添加图片墙图片',
      addCarouselContent: '添加轮播图',
      addVideContent: '添加视频',
      addAvatar: '添加头像',
      addText: '添加文字',
      addPictureBoard: '添加组合图'
    },
    postingChannel: {
      add: '发布',
      public: '公开',
      hidden: '隐藏',
      update: '更新',
      delete: '关闭',
      cancel: '取消',
      syncIndustry: {
        yes: '更新匹配逻辑',
        no: '仅应用于当前职位'
      },
      autoPost: '自动发布'
    },
    calibration: {
      HEIGHT: '高',
      MIDDLE: '中',
      LOW: '低'
    },
    saveAndBack: '保存并返回',
    referralBtn: '推荐',
    applyBtn: '申请',
    reapply: '重新申请',
    applied: '已申请',
    continueFinishApply: '继续完成申请',
    shareBtn: '分享',
    submitBtn: '提交',
    yes: '是',
    no: '否',
    edit: '编辑',
    delete: '删除',
    download: '下载',
    editImgJobPoster: '上传图片',
    editVideoJobPoster: '上传视频',
    testCandidate: '基于这些标准测试'
  },
  message: {
    invalidEmail: '请输入一个有效的邮箱',
    addNewEmailTip: {
      reminder: '此处填写的邮箱用于在每周一接收上周的职位申请概况邮件。若不同职位设定同一邮箱，则该邮箱会收到一封整合的申请概况邮件。',
      resume: '当有求职者完成了工作申请的时候，你将会收到一封邮件，包含该求职者申请信息和简历。'
    },
    resumeTypeTip: {
      BASIC: {
        title: '只包含候选人姓名，手机号，邮箱地址。'
      },
      MINI: {
        title: '在口袋简历中，包括以下候选人信息：',
        contentList: ['基本信息', '联系方式', '最高学历', '毕业院校', '工作经历（包括公司名称,职位和起止时间）'],
        mark: '此简历模板适用于门店基层职位或对候选人无较高背景要求的职位。'
      },
      FULL: {
        title: '在详细简历中，包括以下候选人信息：',
        contentList: ['基本信息', '完整的教育经历', '工作经历', '所获奖项', '相关技能', '附加信息'],
        mark: '此简历模板多适用于校园招聘项目和中高层管理职位。'
      }
    },
    requiredResumeAttachment: '候选人简历附件必填',
    assessmentTip: {
      valuesAssessment: '用于了解求职者针对本公司文化的匹配度。',
      personalityAssessment: '用于了解求职者针对该职位的职业性格匹配度。',
      problemSolutionAssessment: '用于了解求职者的问题解决能力。',
      careerPreferenceAssessment: '用于了解求职者职业和工作的兴趣倾向。'
    },
    openQuestionContainerTip: {
      PRESCREEN: ['请设计一组简短的筛选问题，供聊天机器人在候选人访问职位描述页面时向其提问。候选人的回答将有助于判断其是否符合您的关键要求，并引导符合条件的应聘者提交申请。'],
      NORMAL: ['这部分允许您创建一些简短的问题，申请人必须完成这些问题才能提交申请。', '有五种题：一种是允许任意作答的问答题，一种是选择题，一种是视频答题，一种是附件答题，还有一种是日期答题。'],
      HR: ['这部分允许您创建一些简短的问题，招聘人员可以在管理编辑候选人申请时填写。', '有五种题：一种是允许任意作答的问答题，一种是选择题，一种是视频答题，一种是附件答题，还有一种是日期答题。'],
      INTERVIEW: ['这部分允许您设置面试问卷，招聘人员可以在管理候选人申请时使用。', '有五种题：评分题、文本题、单选题、多选题和日期题。'],
      RATING: ['这部分允许面试官根据候选人在面试过程中的表现进行评价和打分。', '有五种题：评分题、文本题、单选题、多选题和日期题。']
    },
    notFoundPostingChannel: '找不到想发布的渠道？请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    channelPostProcessing: '系统后台正在处理上次发布请求，请等待系统完成上次发布后再进行更新操作。',
    copyApplyUrl: {
      success: '复制成功',
      fail: '复制失败， 请手动复制'
    },
    wrongFileType: '错误的文件类型',
    wrongFileSize: '错误的文件大小， 最大: {fileSize}MB',
    emailIsExisted: '输入的邮箱已经存在',
    locationTip: [
      '请选择城市并且填写具体地址',
      '或是点击地图上的地点，或拖动地图上的图钉以自动填充城市与地址'
    ],
    locationIsExisted: '该地址已存在，请重新设置地址！',
    personalityCalibrationDesc: [
      '本步骤的目的是确认什么样的员工品质适合您提供的职位并能助力成功。通过该步骤您可以获得一份理想的职位描述，据此您可以快速筛选出最适合该职位的申请者。',
      '为了完成这一步骤，您需要根据职位所需要的品质特点的重要性为以下每一项品质打分。如果您针对每项品质只选择一个标准，那么可能在这个职位中，非常匹配的人会非常少，如果您想要更多潜在的匹配的候选人，您可以给每个品质设定多个标准，例如：高+中，当然针对您非常看重的品质，只选择一个选项会带来更好的区分度。',
      '如果您不确定该职位所需的哪些品质最重要，您可以和招聘经理一起完成这一步骤。'
    ],
    calibrationNeedAtLastOne: '至少需要选择一项重要性',
    calibrationCannotOnlyHeightAndLow: '不能只选择“高重要性”和“低重要性”',
    refreshPageWithoutSaveData: '确定重新载入页面？系统不会保存您所做的更改。',
    requireCustomCarousel: '这里可以添加1-7张图片。',
    requireCustomPicture: '这里可以添加1-3张图片。',
    requireCustomVideo: '你好像忘记上传视频啦！',
    requireCustomCarouselFile: '你好像有图片没有上传噢，请检查一下吧！',
    requireCustomVideoFile: '你好像忘记上传视频啦！',
    requireCustomVideoCoverFile: '这个视频好像缺少了一个暖心的封面！',
    requireCustomText: '还未输入文字信息',
    updateJobPostingIndustryMapping: '您选择的行业和后台配置的逻辑不同。你想保存此逻辑还是仅仅应用于当前职位？',
    deleteJobSettingsSuccess: '删除成功！',
    cancelDeleteJobSettings: '已取消删除！',
    saveJobSettingsSuccess: '配置保存成功。',
    jobCloseApplicationSourceStatusRequired: '请选择需要更新的申请状态',
    jobCloseApplicationTargetStatusRequired: '请选择申请的目标状态',
    jobCloseApplicationStatusInvalid: '申请来源状态或目标状态无效，请重新选择',
    jobCancelApplicationSourceStatusRequired: '请选择需要更新的申请状态',
    jobCancelApplicationTargetStatusRequired: '请选择申请的目标状态',
    jobCancelApplicationStatusInvalid: '申请来源状态或目标状态无效，请重新选择',
    saveJobSettingsMessage: '请添加一个配置后保存。',
    requireDescription: '这是一个必填字段',
    requireAvatar: '这是一个必填字段',
    videoEndedTip: '上滑观看下一个视频',
    agreementError: '请同意以上条款再继续。',
    deleteAmbassadorPosterSuccess: '删除成功',
    deleteAmbassadorPosterFail: '删除出错啦，请重试',
    requirementCriterionKeyHasExists: 'Key 已经存在',
    criterionMaxLimit: '最多选取{num}个标准。',
    resolveAddressError: '根据地址查询位置失败',
    pleaseConfirmToPostANewJob: '请先确认发布新职位。',
    jobFitConditionTip: [
      'AJINGA Intelligence 智能提取职位描述中的关键要求。',
      '选择用于人岗匹配评分的输入条件。',
      '支持随时新增或删除，灵活优化。'
    ]
  },
  visibilityType: {
    IE: '内外部可见',
    E: '仅外部可见',
    I: '仅内部可见'
  },
  experienceType: {
    experienced: '有经验的',
    graduate: '学校毕业生'
  },
  roleType: {
    FULL_TIME: '全职',
    PART_TIME: '兼职',
    INTERNSHIP: '实习'
  },
  resumeType: {
    BASIC: '基本注册',
    MINI: '口袋简历',
    FULL: '详细简历'
  },
  openQuestionContainerType: {
    PRESCREEN: '应聘者预筛问卷（聊天机器人）',
    NORMAL: '申请人调查问卷',
    HR: '招聘人员筛选',
    INTERVIEW: '面试问卷',
    RATING: '评分问卷'
  },
  jobStatus: {
    CREATE: '创建',
    ACTIVE: '激活',
    PENDING: '待定',
    REFRESH: '刷新',
    CLOSED: '关闭',
    CANCEL: '取消'
  },
  assessmentType: {
    NORMAL: '正常',
    SIMPLE: '精简'
  },
  personalityDescription: {
    COMPOSURE: {
      title: '沉着',
      content: '很少感到沮丧或恼怒。很有耐心并能很好地控制自己的情绪。'
    },
    RESILIENCE: {
      title: '自我调节',
      content: '乐观自信，能很好地处理压力。能掌控好自己的生活，并迅速战胜挫折。'
    },
    TEAMWORK: {
      title: '合作',
      content: '能敏锐地察觉他人的需要，并很好地进行团队合作。对朋友和同事都很富有同情心并且很忠诚。'
    },
    OUTGOING: {
      title: '外向',
      content: '善于交际、十分健谈且擅长社交。能很容易就交到新朋友，建立新的人际关系。'
    },
    LEADERSHIP: {
      title: '领导能力',
      content: '喜欢掌管一切。喜欢领导和指挥他人。对将采取什么行动有自己明确的主张。'
    },
    MENTAL_AGILITY: {
      title: '思维敏捷',
      content: '您拥有灵活的思维与开放的心态，往往能察觉明显事实下所隐藏的可能性并能以创造性的方法挖掘各种可能性。必要时您愿意冒险。'
    },
    ORGANIZING: {
      title: '条理分明',
      content: '在工作和生活中，更倾向于提前做好规划并保持思清晰路。喜欢遵循规则行事并非常注意细节。'
    },
    DRIVE: {
      title: '推动力',
      content: '志向远大、富有活力、渴望胜利。在忙碌的时候感到最高兴，享受一大堆工作需要完成的工作环境。'
    },
    SERVICING: {
      title: '服务',
      content: '擅于帮助他人、提出解决方案并提供支持。能以积极的态度来看待服务这一职业。'
    },
    SELLING: {
      title: '销售',
      content: '很有技巧，能让人相信一种产品、服务或理念的价值。能以积极的态度来看待销售这一职业。'
    }
  },
  interviewSatisfactionSettingOption: {
    INTERVIEWED: '面试结束后',
    HN_RATED: '招聘经理面试评分后'
  },
  resourceLibrary: {
    requiredVideo: '请选择一个视频'
  }
}
